import { render } from "./basic.vue?vue&type=template&id=7455db03&scoped=true"
import script from "./basic.vue?vue&type=script&lang=js"
export * from "./basic.vue?vue&type=script&lang=js"

import "./basic.vue?vue&type=style&index=0&id=7455db03&scoped=true&lang=scss"
import "./basic.vue?vue&type=style&index=1&id=7455db03&lang=css"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7455db03"]])

export default __exports__